import { policyAndSecurityContent as content } from "./content";

export function PolicyAndSecurity() {
  return (
    <main className="home-page-v2__policy" aria-labelledby="policy-title">
      <div className="home-page-v2__section-inner home-page-v2__policy-inner">
        <header className="home-page-v2__policy-heading">
          <h1 id="policy-title">{content.title}</h1>
          <p className="home-page-v2__policy-updated-at">{content.updatedAt}</p>
          <p className="home-page-v2__policy-public-notice">
            {content.publicNotice}
          </p>
        </header>

        <div className="home-page-v2__policy-grid">
          {content.sections.map((section) => (
            <section className="home-page-v2__policy-section" key={section.title}>
              <h2 className="home-page-v2__policy-section-title">
                {section.title}
              </h2>
              {section.paragraphs.map((paragraph) => (
                <p className="home-page-v2__policy-section-text" key={paragraph}>
                  {paragraph}
                </p>
              ))}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
